export enum PickupState {
  AddPos = 'AddPos',
  ShowPos = 'ShowPos',
  ShowPosOnlyOne = 'ShowPosOnlyOne',
  ShowPosNotAvailable = 'ShowPosNotAvailable',
  NoPosAvailable = 'NoPosAvailable',
}
